import axios from "axios";

export default axios.create({
  //baseURL: `https://0sr2qgly67.execute-api.eu-west-1.amazonaws.com/${process.env.REACT_APP_ENVIRONMENT}/api/v0`,
  baseURL: `https://api-elcosrci.elcos.it/api/v0`,
});
